import type { FaireProductEntity } from "../../entity_types/product";

export const p_wgamzu9wpv: FaireProductEntity = {
  token: "p_wgamzu9wpv",
  type: "product",
  name: "Anua Hearleaf Cream Sheet Mask Night Solution",
  brandName: "Senti Senti",
  imageUrl:
    "https://cdn.faire.com/fastly/164f902e3fbdbcff11db571b8f44d21f9f6ab4d6cdcbd4db7a97d71c81950858.jpeg",
  priceDollars: 3.19,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/c59acc808bf751e0b22a4526ca0040c9c4070edf1265f0ae94423819944c551d.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
